import React, { createContext, useContext, useState, ReactNode } from "react";
import type { ProductBrief } from "../types/productBrief";

interface ProjectContextProps {
  project: any;
  setProject: (project: any) => void;
  description: string;
  setDescription: (description: string) => void;
  productBrief: ProductBrief | null;
  setProductBrief: (brief: ProductBrief | null) => void;
  [key: string]: any;
}

const ProjectContext = createContext<ProjectContextProps | undefined>(
  undefined,
);

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error("useProject must be used within a ProjectProvider");
  }
  return context;
};

export const ProjectProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [project, setProject] = useState<any>(null);
  const [description, setDescription] = useState<string>("");
  const [productBrief, setProductBrief] = useState<ProductBrief | null>(null);

  return (
    <ProjectContext.Provider
      value={{ project, setProject, description, setDescription, productBrief, setProductBrief }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export class Project {
  analysis: any | number;
}
